export default __webpack_public_path__ + "static/result_bg-03cc2ed61feb8abd11d3b90120684877.webp";